<!--
 * @Author: your name
 * @Date: 2021-10-29 10:54:16
 * @LastEditTime: 2023-01-16 11:27:46
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-business\order\preempt\detail.vue
-->
<template>
  <div class="app-container bj-label-colon">
    <BjDivider right-fixed
      >{{ $t('SourcingDetails.Basic') }}
      <template v-slot:right>
        <!-- 寻源失败状态，按钮可以点击，其他状态下按钮置灰不可点击 -->
        <el-button v-if="info.sourcingStatus == '30303'" type="primary" @click="onAppointDelivery"
          >{{ $t('SourcingDetails.Specify') }}</el-button
        >
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
        <BjLogButton
          type="order"
          :default-query="{
            innerOrderNo: info.innerOrderSn,
            action: 'AUTO_SOURING', //寻源动作
          }"
          permission="BusinessOrderSourceIndex_Log"
          :title="info.innerOrderSn"
          api="orderApi"
        />
      </template>
    </BjDivider>

    <div class="bj-row border-no padding-no mt20">
      <div class="bj-col bj-col-18 padding-no bj-item-col-12">
        <el-form ref="form" inline label-width="200px">
          <el-form-item :label="$t('SourcingDetails.order')">
            <span class="link" @click="$toBusinessThirdOrderView(info.orderSn)">{{
              info.orderSn
            }}</span>
            <BjCopyIcon :copy="info.orderSn" />
          </el-form-item>
          <el-form-item :label="$t('SourcingDetails.Internal')">
            <span class="link" @click="$toBusinessOrderInternalView(info.innerOrderSn)">{{
              info.innerOrderSn
            }}</span>
            <BjCopyIcon :copy="info.innerOrderSn" />
          </el-form-item>
          <!-- #ifndef OPEN-SOURCE -->
          <el-form-item :label="$t('SourcingDetails.Doc')">
            <span>{{ info.sourcingSn }}</span>
            <BjCopyIcon :copy="info.sourcingSn" />
          </el-form-item>
          <el-form-item :label="$t('SourcingDetails.creation')">
            {{ info.creationDate }}
          </el-form-item>
          <el-form-item v-if="info.remarks" :label="$t('SourcingDetails.Reason')">
            {{ info.remarks }}
          </el-form-item>
          <!-- #endif -->
        </el-form>
      </div>
      <div class="bj-col bj-col-6 padding-no flex-column flex-center el-progress-box-2022-4-11">
        <!-- #ifndef OPEN-SOURCE -->
        <el-progress
          type="circle"
          :width="160"
          :stroke-width="30"
          :percentage="progressPercentage"
          :format="progressText"
        ></el-progress>
        <!-- #endif -->
      </div>
    </div>
    <!-- #ifndef OPEN-SOURCE -->
    <BjDivider>{{ $t('SourcingDetails.product') }}</BjDivider>
    <GoodsInfoTab
      :order-id="$route.query.id"
      :object-version-number="info.objectVersionNumber"
      has-btn
    />
    <!-- #endif -->
    <AppointDelivery ref="specifyDelivery" @confirm="reFresh" />
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { orderApi } from '@/api';
// #ifndef OPEN-SOURCE
import GoodsInfoTab from './components/GoodsInfoTab';
// #endif
import AppointDelivery from './components/AppointDelivery';
import { ORDER_INTERNAL_SOURCE_STATUS_LIST } from '@/utils/constants';
export default {
  name: 'BusinessOrderSourceView',
  components: { GoodsInfoTab, AppointDelivery },
  mixins: [viewMiXin],
  // provide() {
  //   return {
  //     areaCode: () => this.info.receiverAddress,
  //   };
  // },
  data() {
    return {
      ORDER_INTERNAL_SOURCE_STATUS_LIST,
      info: {
        creationDate: null,
        id: null,
        orderSn: null,
        innerOrderSn: null,
        sourcingSn: null,
        shippingNoticeSn: null,
        sourcingStatus: null,
        skuNum: null,
        successNum: null,
        failedNum: null,
        shopCode: null,
        shopName: null,
        channel: null,
        thirdOrderTime: null,
        payTime: null,
        receiverAddress: null,
      },
    };
  },
  computed: {
    id() {
      return this.$route.query.id || '';
    },
    // #ifndef OPEN-SOURCE
    progressPercentage() {
      // ['30301', '全部待寻源'],
      // ['30302', '全部寻源成功'],
      // ['30303', '全部寻源失败'],
      // ['30304', '部分寻源'],
      let p = 0;
      switch (String(this.info.sourcingStatus)) {
        case '30301':
          p = 0;
          break;
        case '30302':
          p = 100;
          break;
        case '30304':
          p = 50;
          break;
        case '30303':
          p = 0;
          break;
      }
      return p;
    },
    //  #endif
  },
  created() {
    this.reFresh();
  },
  methods: {
    progressText() {
      return (this.$t(ORDER_INTERNAL_SOURCE_STATUS_LIST.bjGet(this.info.sourcingStatus)) || '').replace(
        this.$t('SourcingDetails.All'),
        '',
      );
    },
    onAppointDelivery() {
      const data = {
        orderId: this.id,
        innerOrderSn: this.info.innerOrderSn,
        areaCode: this.info.receiverAddress,
        skuNum: this.info.skuNum,
        objectVersionNumber: this.info.objectVersionNumber,
      };
      this.$refs.specifyDelivery.show(data);
    },
    reFresh() {
      orderApi.getOrderSourcingDetail({ id: this.id }).then(res => {
        this.info = { ...this.info, ...(res || {}) };
      });
    },
    handleClose() {
      this.cancel();
    },
  },
};
</script>
<style>
.el-progress-box-2022-4-11 .el-progress__text {
  font-size: 16px !important;
}
</style>
